function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 16.75h9.5v-1.5h-9.5zm4.75-3.1L15.65 10 14.6 8.95l-1.85 1.825V6.25h-1.5v4.525L9.4 8.95 8.35 10zm0 7.85a9.263 9.263 0 0 1-3.712-.75 9.432 9.432 0 0 1-5.038-5.038 9.563 9.563 0 0 1 0-7.425A9.435 9.435 0 0 1 8.288 3.25a9.563 9.563 0 0 1 7.425 0 9.437 9.437 0 0 1 5.037 5.037 9.563 9.563 0 0 1 0 7.425 9.435 9.435 0 0 1-5.037 5.038A9.27 9.27 0 0 1 12 21.5z",
    transform: "translate(.5 .5)",
    style: {
      fill: "#21a2ee"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadModern);
export default __webpack_public_path__ + "static/media/download_modern.6728520a969348938de2430dc8917248.svg";
export { ForwardRef as ReactComponent };